import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "./Header.css";

const Header: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header-content">
        <div className="logo">
          <Link to="/">
            <h1>
              <span className="logo-full">Michael & Ashlynn</span>
              <span className="logo-short">M & A</span>
            </h1>
          </Link>
        </div>

        <button
          className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle navigation menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`nav ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
          <ul className="nav-list">
            <li>
              <NavLink to="/" end onClick={closeMobileMenu}>
                Home
              </NavLink>
            </li>
            <li>
              <NavLink to="/details" onClick={closeMobileMenu}>Itinerary</NavLink>
            </li>
            <li>
              <NavLink to="/directions" onClick={closeMobileMenu}>Directions</NavLink>
            </li>
            <li>
              <NavLink to="/rsvp" onClick={closeMobileMenu}>RSVP</NavLink>
            </li>
            <li>
              <NavLink to="/gallery" onClick={closeMobileMenu}>Gallery</NavLink>
            </li>
            <li>
              <NavLink to="/seating" onClick={closeMobileMenu}>Seating Chart</NavLink>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
